import { atom as $, getDefaultStore as y } from "jotai";
import t from "zod";
import { toBaseUrlStringOrThrow as R } from "@made-people/types-url-string";
import { jsx as O } from "react/jsx-runtime";
import { createContext as U, useContext as D } from "react";
const d = $(
  void 0
);
d.debugLabel = "gearsConfigurationAtom";
const g = t.enum(["dev", "test", "stage", "prod"]);
function h(e) {
  return g.safeParse(e).success;
}
function b(e) {
  if (h(e))
    return e;
}
const l = t.enum([
  "bff",
  "engage",
  "elevate",
  "algolia",
  "yotpo"
]);
function m(e) {
  return l.safeParse(e).success;
}
function A(e) {
  if (m(e))
    return e;
}
const p = l.array().optional();
function N(e) {
  return p.safeParse(e).success;
}
function P(e) {
  if (N(e))
    return e;
  if (typeof e != "string" || typeof e == "string" && e.length < 1)
    return;
  const r = new Set(
    e.replace(",", " ").replace(" ", " ").split(" ").map((n) => A(n.trim())).filter((n) => typeof n < "u")
  );
  return Array.from(r);
}
const v = t.optional(t.enum(["local", "cluster"]));
function _(e) {
  return v.safeParse(e).success;
}
function w(e) {
  if (_(e))
    return e;
}
const C = t.optional(t.enum(["non-saas", "saas"]));
function I(e) {
  return C.safeParse(e).success;
}
function L(e) {
  if (I(e))
    return e;
}
const G = t.optional(
  t.enum(["frackend.net", "gears.madepeople.dev"])
);
function V(e) {
  return G.safeParse(e).success;
}
function x(e) {
  if (V(e))
    return e;
}
const T = t.object({
  tenantId: t.string(),
  gearsEnvironment: g,
  localServices: p,
  gearsRunMode: v,
  gearsDomain: G,
  gearsClusterMode: C
});
function k(e) {
  return T.keyof().safeParse(e).success;
}
const j = {
  tenantId: "TENANT_ID",
  gearsEnvironment: "GEARS_ENVIRONMENT",
  gearsRunMode: "GEARS_RUN_MODE",
  gearsClusterMode: "GEARS_CLUSTER_MODE",
  gearsDomain: "GEARS_DOMAIN",
  localServices: "LOCAL_SERVICES"
};
function z(e) {
  if (k(e))
    return j[e];
}
function a(e) {
  var r, n, o;
  if (typeof window < "u")
    return (r = y().get(d)) == null ? void 0 : r[e];
  if (typeof process < "u") {
    const s = z(e);
    if (typeof s < "u")
      return (o = (n = process.env) == null ? void 0 : n[s]) == null ? void 0 : o.trim();
  }
}
function S(e, r) {
  const {
    tenantId: n,
    localServices: o,
    gearsDomain: s,
    gearsRunMode: c,
    gearsClusterMode: u,
    gearsEnvironment: f
  } = r;
  let i;
  return o != null && o.includes(e) ? i = `https://${n}.${e}.local.${s}:8080` : typeof window < "u" || c === "local" ? u === "saas" ? i = `https://${n}.${e}.${f}.${s}` : i = `https://${n}-${f}.${e}.${s}` : typeof process < "u" && (u === "saas" ? i = `https://${e}.internal.gears-${f}.net` : i = `http://${e}.${n}-gears-${f}.svc.cluster.local:8080`), R(i);
}
function K(e) {
  if (!m(e))
    return;
  const r = a("tenantId"), n = b(
    a("gearsEnvironment")
  ), o = x(a("gearsDomain")) || "frackend.net";
  if (typeof r > "u" || typeof n > "u")
    return;
  const s = P(
    a("localServices")
  ), c = w(
    a("gearsRunMode")
  ), u = L(
    a("gearsClusterMode")
  );
  return S(e, {
    tenantId: r,
    localServices: s,
    gearsDomain: o,
    gearsRunMode: c,
    gearsClusterMode: u,
    gearsEnvironment: n
  });
}
const E = U(
  void 0
), Q = (e) => /* @__PURE__ */ O(E.Provider, { value: e.gearsConfiguration, children: e.children }), M = () => {
  const e = D(E);
  if (e === void 0)
    throw new Error(
      "useGearsConfiguration must be used within a GearsConfigurationProvider"
    );
  return e;
}, W = (e) => M()[e], X = (e) => {
  const r = M();
  return S(e, r);
};
export {
  Q as GearsConfigurationProvider,
  C as gearsClusterMode,
  d as gearsConfigurationAtom,
  G as gearsDomain,
  g as gearsEnvironment,
  j as gearsEnvironmentVariableNames,
  p as gearsLocalServices,
  v as gearsRunMode,
  l as gearsService,
  a as getGearsConfigurationVariable,
  K as getGearsServiceUrl,
  I as isGearsClusterMode,
  k as isGearsConfigVariable,
  V as isGearsDomain,
  h as isGearsEnvironment,
  N as isGearsLocalServices,
  _ as isGearsRunMode,
  m as isGearsService,
  L as toGearsClusterModeOrUndefined,
  x as toGearsDomainOrUndefined,
  b as toGearsEnvironmentOrUndefined,
  P as toGearsLocalServicesOrUndefined,
  w as toGearsRunModeOrUndefined,
  A as toGearsServiceOrUndefined,
  M as useGearsConfiguration,
  W as useGearsConfigurationVariable,
  X as useGearsServiceUrl
};
//# sourceMappingURL=lib.es.js.map
